import Primary from "../layouts/Primary";
import {t} from "../../i18n";

import './SafetySecurity.css';
import { QRCodeSVG } from "qrcode.react";

export default function SafetySecurity() {
    return <Primary>
        <div className={"safetySecuritySlide"}>
        <h2>{t`Issue Reporting`}</h2>
        <div className={"row"}>
        <div className={"col-4 d-flex flex-column align-items-center justify-content-center"}>
            <QRCodeSVG value={"https://firstinspires.org/report"} size={300} />
            <span className={"qr-label"}>firstinspires.org/report</span>
        </div>
        <ul className={"col-8"}>
            <li>{t`Medical Incidents`}
                <ul>
                    <li>{t`Report the issue to Pit Admin and call the local emergency services number if there is any question of the severity of the injury`}</li>
                    <li>{t`Ensure the person has access to first aid support`}</li>
                    <li dangerouslySetInnerHTML={{__html: t`Work with Pit Admin, Event Director, or other event leadership to complete the incident report on the <i>FIRST</i> Reporting Portal within 24 hours`}}></li>
                </ul>
            </li>
            <li>{t`Youth Safety Concerns`}
                <ul>
                    <li dangerouslySetInnerHTML={{__html: t`You have the right to feel safe and respected at all <i>FIRST</i> Events`}}></li>
                    <li dangerouslySetInnerHTML={{__html: t`Report one-time or ongoing issues such as suspected abuse, bullying, harassment, discrimination, questionable behavior, or violation of the <i>FIRST</i> Code of Conduct`}}></li>
                </ul>
            </li>
        </ul>
        </div>
        </div>
    </Primary>;
}